import {
  APP_NAME,
  BASE_URL,
  FB_PAGE_URL,
  IG_PAGE_URL,
  ORG_DESCRIPTION,
  ORG_EMAIL,
  ORG_LOGO_PATH,
  ORG_TELEPHONE,
  TIKTOK_PAGE_URL,
  TWITTER_PAGE_URL,
  YT_PAGE_URL,
} from '@apps/config';

/**
 * ===========================
 * MAIN
 * ===========================
 */
// absolute url of the brand logo, used by both entities below
export const ORG_LOGO_URL = `${BASE_URL}${ORG_LOGO_PATH}`;

/**
 * `Organization` entity for the publisher.
 * `url` intentionally stays on the unprefixed (English) root for every locale so
 * the three locale variants don't declare three competing organizations.
 */
export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: APP_NAME,
  url: BASE_URL,
  logo: ORG_LOGO_URL,
  description: ORG_DESCRIPTION,
  image: ORG_LOGO_URL,
  sameAs: [
    FB_PAGE_URL,
    IG_PAGE_URL,
    TWITTER_PAGE_URL,
    TIKTOK_PAGE_URL,
    YT_PAGE_URL,
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: ORG_TELEPHONE,
    contactType: 'Customer Service',
    email: ORG_EMAIL,
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '19-21-1, Jalan SR 8/1, Taman Serdang Raya',
    addressLocality: 'Seri Kembangan',
    addressRegion: 'Selangor',
    postalCode: '43300',
    addressCountry: 'MY',
  },
};

/**
 * `WebSite` entity exposing the sitelinks search box.
 * NOTE: the search route of this app is `/search/[keyword]`
 * (see `pages/search/[keyword].tsx` & `layouts/Navbar`), hence the path
 * placeholder rather than a `?q=` query string.
 */
export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: APP_NAME,
  url: BASE_URL,
  description: ORG_DESCRIPTION,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${BASE_URL}/search/{search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
const siteStructuredDataConfig = { organizationSchema, webSiteSchema };

export default siteStructuredDataConfig;
